import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalMessageService, HttpErrorHandler, HttpResponseStatus, Priority } from '@spartacus/core';
import { KnBrCustomerContextAdapter } from 'src/store/kn-br-customer-context/kn-br-customer-context.adapter';

/**
 * Right after login, before a sales area is resolved (or before the no-b2b-units
 * redirect completes), other components on the page issue calls that the backend
 * rejects with an IllegalArgumentError referencing "salesOrg". Suppress only that
 * specific error, and only while no sales area is set yet, so it never flashes on
 * screen; once a sales area is resolved, BadRequestHandler handles 400s as usual.
 */
@Injectable({ providedIn: 'root' })
export class KnBrSalesOrgErrorHandler extends HttpErrorHandler {
  responseStatus = HttpResponseStatus.BAD_REQUEST;

  constructor(globalMessageService: GlobalMessageService, private customerContextAdapter: KnBrCustomerContextAdapter) {
    super(globalMessageService);
  }

  hasMatch(errorResponse: HttpErrorResponse): boolean {
    if (errorResponse.status !== this.responseStatus || this.customerContextAdapter.getSalesArea()) {
      return false;
    }
    const errors = errorResponse.error?.errors || [];
    return errors.some(
      (error: any) => error.type === 'IllegalArgumentError' && String(error.message).toLowerCase().includes('salesorg')
    );
  }

  handleError(): void {
    // no-op: intentionally suppressed
  }

  getPriority(): Priority {
    return Priority.HIGH;
  }
}
